import React from "react";
import { Container, Box, Typography, Divider } from "@mui/material";
/* Icons */
import AccessibilityNewIcon from "@mui/icons-material/AccessibilityNew";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import SportsGymnasticsIcon from "@mui/icons-material/SportsGymnastics";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import ReactPlayer from "react-player";

import { useTranslation } from "react-i18next";

import OurProductFeatures from "../UI/OurProductFeatures";

const ProductPhysioCustomer = () => {
  const { t } = useTranslation();

  return (
    <Container
      sx={{
        minHeight: "100vh", // full screen height
        display: "flex",
        justifyContent: "center", // horizontal center
        alignItems: "center", // vertical center
        px: 4,
      }}
    >
      <Box
        className="white-background"
        sx={{
          width: "100%",
          maxWidth: "100%",
          p: { xs: 2, sm: 4 },
          borderRadius: 2,
          textAlign: "left",
          overflowY: "auto",
        }}
      >
        <Typography variant="h3" color="primary" gutterBottom sx={{ py: 5 }}>
          {t("productEndCustomer.heading")}
        </Typography>

        <Box
          sx={{ display: "flex", justifyContent: "center", marginBottom: 5 }}
        >
          <ReactPlayer
            url="https://vimeo.com/1059501770"
            controls
            width="100%"
            light={true} // shows thumbnail until play
            playing={true}
          />
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box
          style={{
            display: "grid",
            gap: 15,
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          }}
        >
          <OurProductFeatures
            text={t(`physioProduct.section${1}Text`)}
            title={t(`physioProduct.section${1}Title`)}
          >
            <AccessibilityNewIcon sx={{ fontSize: 35 }} />
          </OurProductFeatures>
          <OurProductFeatures
            text={t(`physioProduct.section${2}Text`)}
            title={t(`physioProduct.section${2}Title`)}
          >
            <CalendarMonthIcon sx={{ fontSize: 35 }} />
          </OurProductFeatures>
          <OurProductFeatures
            text={t(`physioProduct.section${3}Text`)}
            title={t(`physioProduct.section${3}Title`)}
          >
            <OndemandVideoIcon sx={{ fontSize: 35 }} />
          </OurProductFeatures>
          <OurProductFeatures
            text={t(`physioProduct.section${4}Text`)}
            title={t(`physioProduct.section${4}Title`)}
          >
            <SkipNextIcon sx={{ fontSize: 35 }} />
          </OurProductFeatures>
          <OurProductFeatures
            text={t(`physioProduct.section${5}Text`)}
            title={t(`physioProduct.section${5}Title`)}
          >
            <SportsGymnasticsIcon sx={{ fontSize: 35 }} />
          </OurProductFeatures>
          <OurProductFeatures
            text={t(`physioProduct.section${6}Text`)}
            title={t(`physioProduct.section${6}Title`)}
          >
            <SettingsSuggestIcon sx={{ fontSize: 35 }} />
          </OurProductFeatures>
        </Box>

        <Divider sx={{ my: 4 }} />
      </Box>
    </Container>
  );
};

export default ProductPhysioCustomer;
